/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateLogEntryCommandControllerCreate201,
  CreateLogEntryDto,
  ListLogHistoryQueryControllerListParams,
  ListLogHistoryResponseDto,
  LogEntryResponseDto,
  LogTypeResponseDto,
  OpenIncidentResponseDto,
  TodaySessionResponseDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Create a new log entry
 */
export const createLogEntryCommandControllerCreate = (
  nurseryId: string,
  createLogEntryDto: CreateLogEntryDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateLogEntryCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/log-entries`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createLogEntryDto,
    signal,
  });
};

export const getCreateLogEntryCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLogEntryCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateLogEntryDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLogEntryCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateLogEntryDto },
  TContext
> => {
  const mutationKey = ["createLogEntryCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLogEntryCommandControllerCreate>>,
    { nurseryId: string; data: CreateLogEntryDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return createLogEntryCommandControllerCreate(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLogEntryCommandControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLogEntryCommandControllerCreate>>
>;
export type CreateLogEntryCommandControllerCreateMutationBody =
  CreateLogEntryDto;
export type CreateLogEntryCommandControllerCreateMutationError = void;

/**
 * @summary Create a new log entry
 */
export const useCreateLogEntryCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLogEntryCommandControllerCreate>>,
      TError,
      { nurseryId: string; data: CreateLogEntryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createLogEntryCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateLogEntryDto },
  TContext
> => {
  return useMutation(
    getCreateLogEntryCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List active log types for a nursery
 */
export const listLogTypesQueryControllerList = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<LogTypeResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/log-types`,
    method: "GET",
    signal,
  });
};

export const getListLogTypesQueryControllerListQueryKey = (
  nurseryId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/log-types`] as const;
};

export const getListLogTypesQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListLogTypesQueryControllerListQueryKey(nurseryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLogTypesQueryControllerList>>
  > = ({ signal }) => listLogTypesQueryControllerList(nurseryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListLogTypesQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLogTypesQueryControllerList>>
>;
export type ListLogTypesQueryControllerListQueryError = void;

export function useListLogTypesQueryControllerList<
  TData = Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listLogTypesQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLogTypesQueryControllerList<
  TData = Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listLogTypesQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLogTypesQueryControllerList<
  TData = Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List active log types for a nursery
 */

export function useListLogTypesQueryControllerList<
  TData = Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogTypesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListLogTypesQueryControllerListQueryOptions(
    nurseryId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List today's log sessions with entry counts for a nursery
 */
export const listTodaySessionsQueryControllerList = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<TodaySessionResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/log-sessions/today`,
    method: "GET",
    signal,
  });
};

export const getListTodaySessionsQueryControllerListQueryKey = (
  nurseryId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/log-sessions/today`] as const;
};

export const getListTodaySessionsQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTodaySessionsQueryControllerListQueryKey(nurseryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>
  > = ({ signal }) => listTodaySessionsQueryControllerList(nurseryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTodaySessionsQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>
>;
export type ListTodaySessionsQueryControllerListQueryError = void;

export function useListTodaySessionsQueryControllerList<
  TData = Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTodaySessionsQueryControllerList<
  TData = Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTodaySessionsQueryControllerList<
  TData = Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List today's log sessions with entry counts for a nursery
 */

export function useListTodaySessionsQueryControllerList<
  TData = Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTodaySessionsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListTodaySessionsQueryControllerListQueryOptions(
    nurseryId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get all entries for a log session
 */
export const getSessionEntriesQueryControllerGet = (
  sessionId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<LogEntryResponseDto[]>({
    url: `/v1/log-sessions/${sessionId}/log-entries`,
    method: "GET",
    signal,
  });
};

export const getGetSessionEntriesQueryControllerGetQueryKey = (
  sessionId: string,
) => {
  return [`/v1/log-sessions/${sessionId}/log-entries`] as const;
};

export const getGetSessionEntriesQueryControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
  TError = void,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSessionEntriesQueryControllerGetQueryKey(sessionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>
  > = ({ signal }) => getSessionEntriesQueryControllerGet(sessionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSessionEntriesQueryControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>
>;
export type GetSessionEntriesQueryControllerGetQueryError = void;

export function useGetSessionEntriesQueryControllerGet<
  TData = Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
  TError = void,
>(
  sessionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSessionEntriesQueryControllerGet<
  TData = Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
  TError = void,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSessionEntriesQueryControllerGet<
  TData = Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
  TError = void,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all entries for a log session
 */

export function useGetSessionEntriesQueryControllerGet<
  TData = Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
  TError = void,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSessionEntriesQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSessionEntriesQueryControllerGetQueryOptions(
    sessionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List log history for a nursery (manager review)
 */
export const listLogHistoryQueryControllerList = (
  nurseryId: string,
  params: ListLogHistoryQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListLogHistoryResponseDto>({
    url: `/v1/nurseries/${nurseryId}/log-sessions/history`,
    method: "GET",
    params,
    signal,
  });
};

export const getListLogHistoryQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListLogHistoryQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/log-sessions/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListLogHistoryQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: ListLogHistoryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListLogHistoryQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>
  > = ({ signal }) =>
    listLogHistoryQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListLogHistoryQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>
>;
export type ListLogHistoryQueryControllerListQueryError = void;

export function useListLogHistoryQueryControllerList<
  TData = Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: ListLogHistoryQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLogHistoryQueryControllerList<
  TData = Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: ListLogHistoryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLogHistoryQueryControllerList<
  TData = Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: ListLogHistoryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List log history for a nursery (manager review)
 */

export function useListLogHistoryQueryControllerList<
  TData = Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: ListLogHistoryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLogHistoryQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListLogHistoryQueryControllerListQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns each unresolved out-of-range incident, including the fridge name and the triggering log entry. NAU-95 ships read-only; NAU-219 will add a resolve action.
 * @summary List open out-of-range fridge incidents for a nursery
 */
export const listOpenIncidentsQueryControllerList = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<OpenIncidentResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/out-of-range-incidents/open`,
    method: "GET",
    signal,
  });
};

export const getListOpenIncidentsQueryControllerListQueryKey = (
  nurseryId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/out-of-range-incidents/open`] as const;
};

export const getListOpenIncidentsQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOpenIncidentsQueryControllerListQueryKey(nurseryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>
  > = ({ signal }) => listOpenIncidentsQueryControllerList(nurseryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOpenIncidentsQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>
>;
export type ListOpenIncidentsQueryControllerListQueryError = void;

export function useListOpenIncidentsQueryControllerList<
  TData = Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOpenIncidentsQueryControllerList<
  TData = Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOpenIncidentsQueryControllerList<
  TData = Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List open out-of-range fridge incidents for a nursery
 */

export function useListOpenIncidentsQueryControllerList<
  TData = Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenIncidentsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOpenIncidentsQueryControllerListQueryOptions(
    nurseryId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
